import React from 'react';
import PropTypes from 'prop-types';
import './SearchBar.scss';

const SearchBar = ({ onInputChange, value, }) => {
  return (
    <span className="searchbar">
      <input onChange={onInputChange} value={value} type="text" className="searchbar__input" />
      <i className="material-icons">search</i>
    </span>
  );
};

SearchBar.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SearchBar;
